import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';
import { HostType } from '../../types';

export enum ExternalPanelsAPIErrorCode {
  EditorPointerAPINotProvided = 'EditorPointerAPINotProvided',
  CantGetNamespace = 'CantGetNamespace',
}

class ExternalPanelsAPIError extends BaseError<ExternalPanelsAPIErrorCode> {
  constructor(message: string, code: ExternalPanelsAPIErrorCode) {
    super(message, code, 'EP ExternalPanelsAPIError Error');
  }

  withDefineNamespaceData(data: {
    namespaceToRetrieve: string;
    methodName: string;
  }) {
    this.state = {
      ...this.state,
      ...data,
    };

    return this;
  }

  withHostType(hostType: HostType) {
    this.state = {
      ...this.state,
      hostType,
    };

    return this;
  }
}

export const createEditorPlatformPrivateAPIError = createErrorBuilder<
  ExternalPanelsAPIErrorCode,
  ExternalPanelsAPIError
>(ExternalPanelsAPIError);
